import { useCallback, useState } from "react";

interface UseInputProps {
    initialValue: string;
    validateValue: (enteredValue: string,extraValidationParameter?:string) => {isValid:boolean, errorMessage: string};
}

const useInput = ({ initialValue, validateValue }: UseInputProps) => {
    const [enteredValue, setEnteredValue] = useState(initialValue);
    const [isTouched, setIsTouched] = useState(false);

    const {isValid,errorMessage} = validateValue(enteredValue);
    const hasError = !isValid && isTouched;

    const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEnteredValue(e.target.value);
    };
    const inputBlurHandler = () => {
        setIsTouched(true);
    }
    const reset = useCallback(() => {
      setEnteredValue('');
      setIsTouched(false);
  }, []);

    return { value:enteredValue,isValid,errorMessage, hasError, valueChangeHandler , inputBlurHandler , reset };
}
export default useInput;